module.exports = __webpack_public_path__ + "img/mid-preview.94b8a5dc.png";